function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.438 2.813h-7.313V1.125a.56.56 0 00-.666-.552l-9 1.688A.56.56 0 000 2.813v12.375c0 .27.192.503.459.552l9 1.688a.56.56 0 00.666-.552v-1.688h7.313c.31 0 .562-.252.562-.563V3.375a.563.563 0 00-.563-.562zM7.736 10.88a.561.561 0 11-.846.74L5.253 9.752l-1.435 1.845a.565.565 0 01-.79.098.564.564 0 01-.098-.79l1.568-2.016-1.547-1.768a.561.561 0 11.847-.74l1.404 1.604L6.87 5.843a.563.563 0 01.888.691l-1.8 2.313 1.779 2.033zm9.139 3.183h-6.75v-1.125h1.688a.563.563 0 000-1.125h-1.688v-1.125h1.688a.563.563 0 000-1.125h-1.688V8.438h1.688a.563.563 0 000-1.125h-1.688V6.188h1.688a.563.563 0 000-1.125h-1.688V3.938h6.75v10.125z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.188 5.063h-1.126a.563.563 0 000 1.125h1.126a.563.563 0 000-1.125zM15.188 7.313h-1.126a.563.563 0 000 1.125h1.126a.563.563 0 000-1.125zM15.188 9.563h-1.126a.563.563 0 000 1.125h1.126a.563.563 0 000-1.125zM15.188 11.813h-1.126a.563.563 0 000 1.125h1.126a.563.563 0 000-1.125z",
  fill: "#fff"
});

function SvgIconExcell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconExcell;